type Props = {
  children: JSX.Element;
};

export const AuthLayout = (props: Props) => {
  const { children } = props;

  return <div className="auth-wrapper">{children}</div>;
};
